<template>
  <div class="service-wrapper">
    <Title
      title="智慧服务"
      subTitle="Intelligent Care"
      @showMore="showMore"
    ></Title>
    <!-- 日周月 -->
    <div class="service-date">
      <div
        v-for="item in dateList"
        :class="currentDate === item.value ? 'choose-date' : ''"
        :key="item.value"
        class="service-date-item"
        @click="chooseDate(item.value)"
      >
        {{ item.name }}
      </div>
    </div>
    <!-- 服务事项 -->
    <div class="service-container">
      <div
        class="service-container-item"
        v-for="item in itemList"
        :key="item.name"
      >
        <div class="service-container-item-value">
          {{ item.value }}
        </div>
        <div class="service-container-item-name">
          <img class="service-container-item-icon" :src="item.icon" alt />
          {{ item.name }}
        </div>
      </div>
    </div>
    <!-- 线上点单统计 -->
    <div class="online-order-chart-con">
      <div class="title-item">
        <div class="title-icon"></div>
        <div>
          线上点单统计<span class="number-color">{{ orderNum }}</span
          >次
        </div>
      </div>
      <div id="onlineCharts"></div>
    </div>
    <!-- 次数统计 -->
    <div class="number-statistics">
      <div>
        移动端登录次数&nbsp;<span class="number-color">{{
          serviceData && serviceData.data && serviceData.data.data
            ? serviceData.data.data.loginCount
            : null
        }}</span
        >&nbsp;次
      </div>
      <div>
        意见反馈次数&nbsp;<span class="number-color">{{
          serviceData && serviceData.data && serviceData.data.data
            ? serviceData.data.data.adviceCount
            : null
        }}</span
        >&nbsp;次
      </div>
    </div>
  </div>
</template>

<script>
import Title from "@/components/Commen/Title";
const echarts = require("echarts");
import statisticsChart from "./charts/statistics";
import { mapState, mapActions } from "vuex";
import pollingFunction from "@/utils/tools";

export default {
  components: {
    Title,
  },
  data() {
    return {
      dateList: [
        {
          name: "月",
          value: "month",
        },
        {
          name: "周",
          value: "week",
        },
        {
          name: "日",
          value: "day",
        },
      ],
      currentDate: "day",
      yearMonthStart: "2022-01",
      yearMonthEnd: "2022-05",
      branchId: 6627,
      itemList: [
        {
          name: "预约参观",
          value: null,
          icon: require("./../../../src/assets/svgIcon/reservation.svg"),
        },
        {
          name: "访客管理",
          value: null,
          icon: require("./../../../src/assets/svgIcon/person.svg"),
        },
        {
          name: "入院申请",
          value: null,
          icon: require("./../../../src/assets/svgIcon/enter.svg"),
        },
        {
          name: "出院申请",
          value: null,
          icon: require("./../../../src/assets/svgIcon/getOut.svg"),
        },
        {
          name: "入院办理",
          value: null,
          icon: require("./../../../src/assets/svgIcon/enter.svg"),
        },
        {
          name: "出院办理",
          value: null,
          icon: require("./../../../src/assets/svgIcon/getOut.svg"),
        },
      ],
      orderNum: 133,
      pollingST: null,
    };
  },
  computed: {
    ...mapState(["serviceData"]),
  },
  async mounted() {
    // 调用轮询;
    if (!this.pollingST) {
      setTimeout(() => {
        this.pollingST = pollingFunction(this.getData, 3000);
      }, 3000);
    }
    await this.getData();
  },
  methods: {
    ...mapActions(["getServiceData"]),
    async getData() {
      let json = {
        callInfoDateType: this.currentDate,
        yearMonthStart: this.yearMonthStart,
        yearMonthEnd: this.yearMonthEnd,
        branchId: this.branchId,
        callInfoDate: this.getTime(),
      };
      await this.getServiceData(json);
      if (this.serviceData) {
        this.$set(
          this.itemList[0],
          "value",
          this.serviceData.data.data.yycgCount
        );
        this.$set(
          this.itemList[1],
          "value",
          this.serviceData.data.data.fktsCount
        );
        this.$set(
          this.itemList[2],
          "value",
          this.serviceData.data.data.intoCountApply
        );
        this.$set(
          this.itemList[3],
          "value",
          this.serviceData.data.data.checkOutApplyCount
        );
        this.$set(
          this.itemList[4],
          "value",
          this.serviceData.data.data.intoCount
        );
        this.$set(
          this.itemList[5],
          "value",
          this.serviceData.data.data.checkOutCount
        );
        this.drawChart(this.serviceData);
      }
    },
    getTime() {
      let date_ = new Date();
      let seperator1 = "-";
      let year = date_.getFullYear();
      let month = date_.getMonth() + 1;
      let strDate = date_.getDate();
      return year + seperator1 + month + seperator1 + strDate;
    },
    showMore() {
      this.$store.commit("setServiceDrawer", true);
      this.$store.commit("setCurrentMenu", "service");
    },
    async chooseDate(value) {
      if (value == this.currentDate) return;
      this.currentDate = value;
      await this.getData();
    },
    drawChart(res) {
      this.orderNum = res.data.data.onlineOrderStatistics.total;
      let data = res.data.data.onlineOrderStatistics.list.map((el) => {
        return {
          value: el.typeQuantity,
          name: el.typeName,
        };
      });
      this.onlineCharts = echarts.init(document.getElementById("onlineCharts"));
      this.onlineCharts.setOption(statisticsChart(data));
    },
  },
  destroyed() {
    clearTimeout(this.pollingST);
  },
};
</script>

<style lang="scss" scoped>
.service-wrapper {
  width: 460px;
  position: relative;
  top: -30px;
}
.title-con ::v-deep .devide-line {
  margin-bottom: 3px;
}
.service-date {
  color: rgba(255, 255, 255, 0.63);
  font-size: 15px;
  display: flex;
  flex-direction: row-reverse;
  padding: 0 10px;
  .service-date-item {
    padding-left: 10px;
    cursor: pointer;
  }
}
.choose-date {
  color: rgb(237, 255, 0);
}
.number-color {
  color: rgb(237, 255, 0);
}
.service-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;

  .service-container-item {
    height: 70px;
    width: 105px;
    color: #fff;
    background-color: rgba(24, 24, 24, 0.6);
    margin: 5px 10px 15px 0;
    .service-container-item-value {
      font-size: 26px;
      text-align: right;
      padding: 10px 20px 0 10px;
      letter-spacing: -2px;
    }
    .service-container-item-name {
      display: flex;
      align-items: center;
      font-size: 14px;
      padding: 0 15px 0 5px;

      .service-container-item-icon {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }
    }
  }
}

.number-statistics {
  position: absolute;
  top: 275px;
  left: 240px;
  color: rgb(222, 246, 255);
  display: inline-block;
}

.online-order-chart-con {
  width: 204px;
  position: relative;
  top: -100px;
  left: 10px;
  .title-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #fff;
    font-weight: normal;
    font-family: "Microsoft Yahei", Arial, "sans-serif";
    font-size: 16px;
    writing-mode: horizontal-tb;
    .title-icon {
      width: 38px;
      height: 38px;
      border-radius: 5px;
      background-image: url("../../assets/index/fwtj.svg");
      mask: url("../../assets/index/fwtj.svg") no-repeat 50% 50%;
      -webkit-mask-size: cover;
      background-color: rgb(197, 255, 255);
      mask-size: cover;
      margin-right: 10px;
    }
  }
}
#onlineCharts {
  width: 200px;
  height: 200px;
}
</style>
